'use strict';

angular.module('adminEmailTemplatesControllers')

.controller('EmailTemplateController', ['$scope', 'adminEmailTemplatesService', 'emailTemplate', function ($scope, adminEmailTemplatesService, emailTemplate) {

    $scope.emailTemplate = emailTemplate;

    $scope.urlEditEmailTemplate = function () {
        return '/Administration/EmailTemplate/Edit/' + emailTemplate.Code;
    }

    $scope.saveChanges = function (isValid) {
        if (isValid) {
            adminEmailTemplatesService.updateConfigTemplate(this.emailTemplate)
            .then(function (udpatedEmailTemplate) {
                $scope.emailTemplate = udpatedEmailTemplate;
            });
        }
    };

}]);
